<div class="container-header header-font-size">
  {{'R0000.R0001' | translate}}
</div>
<div class="container-detail">
  <nz-spin [nzSpinning]="isSpinning">
    <div nz-row class="title-text sub-header-font-size">
      {{'R0000.R0002' | translate}}
    </div>
    <form nz-form [formGroup]="inputForm">
      <div nz-row *ngIf="!disableSearch">
        <div nz-col nzMd="9" nzXl="9" style="text-align: right;">
          <div class="label-input body-font-size" style="padding-top: 5px;">{{'R0000.R0003' | translate}} : </div>
        </div>
        <div nz-col nzMd="9" nzXl="8">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="claimNumber">
              <input #refNo nz-input type="text" class="form-control input-radius body-font-size"
                onkeyup="this.value = this.value.toUpperCase();"
                style="background-color: white;" maxlength="10" formControlName="claimNumber" (keydown.enter)="searchInsuredReport()" autofocus>
                <ng-template #claimNumber let-control>
                  <ng-container *ngIf="claimNumberValifation.invalid || claimNumberValifation.errors.minlength">
                    <div class="body-font-size">
                      {{'A0000.A0037' | translate}}
                    </div>
                  </ng-container>
                </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <nz-form-control>
      <div nz-row>
        <div nz-col nzSpan="12" class="pr-1">
          <div class="btn-wrapper" style="text-align: right;">
            <div class="btn-styles btn-blue text-center  body-font-size" style="cursor: pointer;"
              (click)="searchInsuredReport()">
              <div class="txt">
                <button type="button" class="body-font-size" style="cursor: pointer;">{{'R0000.R0004' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div nz-col nzSpan="12" class="pl-1">
          <div class="btn-wrapper" style="text-align: left;">
            <div class="btn-styles btn-gray text-center body-font-size" style="cursor: pointer;" (click)="clearData()">
              <div class="txt">
                <button type="button" class="body-font-size" style="cursor: pointer;">{{'R0000.R0005' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-form-control>
  </nz-spin>
</div>
<div>&nbsp;</div>
<router-outlet *ngIf="isShowResult"></router-outlet>